import { reactive } from 'vue';

const tableChanges = reactive({});

export function useRealTimeSync() {
    const touchTable = (tableName) => {
        tableChanges[tableName] = Date.now();
    };

    const getLastChange = (tableName) => {
        return tableChanges[tableName] || 0;
    };

    return { tableChanges, touchTable, getLastChange };
}
